// extracted by mini-css-extract-plugin
export default {"fieldset":"CaseField_fieldset__VV-T5","legend":"CaseField_legend__sR0J4"};